import { Logo } from '@/components/icons';
import { useBrand } from '@/lib/brand/BrandContext';
import { cn } from '@/lib/utils';

type BrandLogoProps = {
  className?: string;
  showText?: boolean;
};

const NYLA_SOURCE_LOGO_FILE = 'NylaNovaStemTransparent4.png';
const NYLA_TRIMMED_LOGO_FILE = 'NylaNovaStemTransparent4-trimmed.png';
const NYLA_MARK_FILE = 'NylaNovaStemMark.png';

const getNylaLogoSrc = (logoSrc: string, showText: boolean) => {
  if (!logoSrc.includes(NYLA_SOURCE_LOGO_FILE)) {
    return logoSrc;
  }

  return logoSrc.replace(
    NYLA_SOURCE_LOGO_FILE,
    showText ? NYLA_TRIMMED_LOGO_FILE : NYLA_MARK_FILE
  );
};

const NylaLogo = ({
  className,
  showText = true,
  logoSrc,
  alt,
}: BrandLogoProps & { alt: string; logoSrc: string }) => {
  const resolvedLogoSrc = getNylaLogoSrc(logoSrc, showText);

  return (
    <img
      src={resolvedLogoSrc}
      alt={alt}
      className={cn(
        showText ? 'h-14 w-auto object-contain' : 'h-10 w-10 object-contain',
        className
      )}
    />
  );
};

export const BrandLogo = ({ className, showText = true }: BrandLogoProps) => {
  const brand = useBrand();

  if (brand.brandKey === 'nyla') {
    return (
      <NylaLogo
        className={className}
        showText={showText}
        alt={`${brand.appName} logo`}
        logoSrc={brand.logoSrc}
      />
    );
  }

  return (
    <Logo
      className={className}
      width={showText ? 250 : 56}
      height={showText ? 100 : 56}
    />
  );
};
